export default {
	Requirement:[{
            'label': ['The information is provided by VTC Occupation Dictionary.  More details are available at [link]'],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': ['此項資料由VTC 職業資料庫提供。您可以在[link]閱覽更多資料。 '],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': ['此项数据由VTC 职业数据库提供。您可以在[link]阅览更多数据。 '],
            'link': '',
            'langCode': 'zh_CN'
        }],
    Experience:[{
            'label': ['The information is provided by VTC Occupation Dictionary.  More details are available at [link]'],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': ['此項資料由VTC 職業資料庫提供。您可以在[link]閱覽更多資料。 '],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': ['此项数据由VTC 职业数据库提供。您可以在[link]阅览更多数据。 '],
            'link': '',
            'langCode': 'zh_CN'
        }],
    EducationLevel:[{
            'label': ['The information is provided by VTC Occupation Dictionary.  More details are available at [link]'],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': ['此項資料由VTC 職業資料庫提供。您可以在[link]閱覽更多資料。 [link]'],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': ['此项数据由VTC 职业数据库提供。您可以在[link]阅览更多数据。 [link]'],
            'link': '',
            'langCode': 'zh_CN'
        }],
    Skills:[{
            'label': [
                'The Top 10 common skills refer to the most common skills reported in LinkedIn member profiles by those LinkedIn members working in that particular occupation in Hong Kong.  Global data were adopted for some occupations with insufficient local data.',
                'The Top 10 growing skills refer to the fastest growing skills over the past 12 months reported in LinkedIn member profiles by those LinkedIn members working in that particular occupation in Hong Kong. Global data were adopted for some occupations with insufficient local data.',
                'The information is retrieved from LinkedIn Talent Insights (LTI), which provides aggregated statistics of LinkedIn member profiles.',
            ],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': [
                '十大常見技能 是指從事該職業的香港LinkedIn會員在會員資料當中最常填報的技能。有小部分職業由於沒有足夠的本地資料而採用了LinkedIn 全球會員資料作為統計。',
                '十大高增長技能 是指從事此職業的香港LinkedIn會員，在過去十二個月在會員資料填報的技能中錄得最快增長的技能。有小部分職業由於沒有足夠的本地資料而採用了LinkedIn 全球會員資料作為統計。',
                '此項資料是從LinkedIn Talent Insights (LTI) 當中取得。LTI是一個提供LinkedIn會員資料分析的平台。',
            ],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': [
                '十大常见技能 是指从事该职业的香港LinkedIn会员在会员资料当中最常填报的技能。有小部分职业由于没有足够的本地资料而采用了LinkedIn 全球会员资料作为统计。',
                '十大高增长技能 是指从事此职业的香港LinkedIn会员，在过去十二个月在会员资料填报的技能中录得最快增长的技能。有小部分职业由于没有足够的本地资料而采用了LinkedIn 全球会员资料作为统计。',
                '此项资料是从LinkedIn Talent Insights (LTI) 当中取得。LTI是一个提供LinkedIn会员数据分析的平台。',
            ],
            'link': '',
            'langCode': 'zh_CN'
        }],
    Manpoweroutlook:[{
            'label': [
                'Projected demand refers to the projected growth of employment opportunities of the selected occupation in the medium term, in which reference was made in a very crude manner to the results of "Manpower Projection to 2027" on the projected manpower requirements of the relevant yet broad "occupation group by economic sector" matrix that this occupation belongs.',
            ],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': [
                '就業前景是指所選職業未來中期的預計就業機會增長，其中粗略地參考了「2027 年人力資源推算」結果中該職業所屬的相關但概括的「按經濟行業劃分的職業組別」人力需求推算。',
               
            ],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': [
                '就业前景是指所选职业未来中期的预计就业机会增长，其中粗略地参考了「2027 年人力资源推算」结果中该职业所属的相关但概括的「按经济行业划分的职业组别」人力需求推算。',
              
            ],
            'link': '',
            'langCode': 'zh_CN'
        }],
    Automationpotential:[{
            'label': [
                'The automation potential is a compiled based on results of the [link] "A future that works: Automation, employment, and productivity" published by McKinsey Global Institute in 2017 .  ',
                'The automation potential refers to the proportion of the work activities that can be automated by adapting currently demonstrated technology, while other factors (such as labour cost, cost of deploying automation, economic benefits, social acceptance, etc.) are NOT considered.  ',
                'The results of the original study were adjusted to match the occupations in Talent.gov.hk using weightings of both Hong Kong and US employment figures.',
            ],
            "link_text":"research report",
            'link': 'https://www.mckinsey.com/~/media/mckinsey/featured%20insights/Digital%20Disruption/Harnessing%20automation%20for%20a%20future%20that%20works/MGI-A-future-that-works-Full-report.ashx',
            'langCode': 'en_US'
        },{
            'label': [
                '自動化可能性根據麥肯錫全球研究所(McKinsey Global Institute) 在2017年1月發表的"A future that works: Automation, employment, and productivity"當中的[link]編製。',
                '研究當中的自動化可能性是指按現有技術能夠將工作活動自動化的比例，而其他因素（例如勞動成本、自動化成本、經濟誘因、社會接受程度等）並沒有考慮在內。',
                '原始研究的結果及後經過香港及美國就業人口統計數字的加權調整，以配合Talent.gov.hk所涵蓋的職業組別。',
            ],
            "link_text":"研究結果",
            'link': 'https://www.mckinsey.com/~/media/mckinsey/featured%20insights/Digital%20Disruption/Harnessing%20automation%20for%20a%20future%20that%20works/MGI-A-future-that-works-Full-report.ashx',
            'langCode': 'zh_HK'
        },{
            'label': [
                '自动化可能性根据麦肯锡全球研究所(McKinsey Global Institute) 在2017年1月发表的"A future that works: Automation, employment, and productivity"当中的[link]编制。',
                '研究当中的自动化可能性是指按现有技术能够将工作活动自动化的比例，而其他因素（例如劳动成本、自动化成本、经济诱因、社会接受程度等）并没有考虑在内。',
                '原始研究的结果及后经过香港及美国就业人口统计数字的加权调整，以配合Talent.gov.hk所涵盖的职业组别。',
            ],
            "link_text":"研究结果",
            'link': 'https://www.mckinsey.com/~/media/mckinsey/featured%20insights/Digital%20Disruption/Harnessing%20automation%20for%20a%20future%20that%20works/MGI-A-future-that-works-Full-report.ashx',
            'langCode': 'zh_CN'
        }],
    CareerPath:[{
            'label': [
                'The information is provided by VTC Occupation Dictionary.  More details are available at [link].',
            ],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': [
                '此項資料由VTC 職業資料庫提供。您可以在[link]閱覽更多資料。',
            ],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': [
                '此项数据由VTC 职业数据库提供。您可以在[link]阅览更多数据。',
            ],
            'link': '',
            'langCode': 'zh_CN'
        }],
    RelatedJobOpportunities:[{
            'label': [
                'Information on related job opportunities of the private sector is provided by LinkedIn, while those of the Government (including Civil Servants and Non-Civil Service Contract Staff (NCSC)) is provided by Civil Service Bureau.',
            ],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': [
                '私營機構的相關職位空缺資訊由LinkedIn提供，而政府（包括公務員及非公務員合約員工）的職位空缺資訊由公務員事務局提供。',
            ],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': [
                '私营机构的相关职位空缺信息由LinkedIn提供，而政府（包括公务员及非公务员合约员工）的职位空缺信息由公务员事务局提供。',
            ],
            'link': '',
            'langCode': 'zh_CN'
        }],
    RelatedCourses:[{
            'label': [
                'Related courses comprises of two main sources - Information on local courses are originated from the Qualifications Register, while the Mass Open Online Courses (MOOC) are originated from edX Course Catalog API.',
            ],
            'link': '',
            'langCode': 'en_US'
        },{
            'label': [
                '相關課程包括兩個主要來源 - 本地課程的資料來自資歷名冊，而MOOC課程（大眾開放線上課程）的資料則來自edX Course Catalog API。',
            ],
            'link': '',
            'langCode': 'zh_HK'
        },{
            'label': [
                '相关课程包括两个主要来源 - 本地课程的资料来自资历名册，而MOOC课程（大众开放在线课程）的资料则来自edX Course Catalog API。',
            ],
            'link': '',
            'langCode': 'zh_CN'
        }],
    VTCLink:[{
            "id": 4171,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Senior-Government-Officials",
            "langCode": "en_US"
        }, {
            "id": 4171,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Senior-Government-Officials",
            "langCode": "zh_HK"
        }, {
            "id": 4171,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Senior-Government-Officials",
            "langCode": "zh_CN"
        }, {
            "id": 4173,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Audit-Managers",
            "langCode": "en_US"
        }, {
            "id": 4173,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Audit-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4173,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Audit-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4174,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Human-Resources-Managers",
            "langCode": "en_US"
        }, {
            "id": 4174,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Human-Resources-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4174,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Human-Resources-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4175,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Business-Support-Managers",
            "langCode": "en_US"
        }, {
            "id": 4175,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Business-Support-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4175,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Business-Support-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4176,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Advertising-Promotion-Managers",
            "langCode": "en_US"
        }, {
            "id": 4176,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Advertising-Promotion-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4176,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Advertising-Promotion-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4177,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Public-Relations-Managers",
            "langCode": "en_US"
        }, {
            "id": 4177,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Public-Relations-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4177,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Public-Relations-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4178,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Research-Development-Managers",
            "langCode": "en_US"
        }, {
            "id": 4178,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Research-Development-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4178,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Research-Development-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4179,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Customer-Service-Managers",
            "langCode": "en_US"
        }, {
            "id": 4179,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Customer-Service-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4179,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Customer-Service-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4180,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Managers-Agriculture-Fishery",
            "langCode": "en_US"
        }, {
            "id": 4180,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Managers-Agriculture-Fishery",
            "langCode": "zh_HK"
        }, {
            "id": 4180,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Managers-Agriculture-Fishery",
            "langCode": "zh_CN"
        }, {
            "id": 4182,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Construction-Managers",
            "langCode": "en_US"
        }, {
            "id": 4182,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Construction-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4182,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Construction-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4183,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/BIM-Managers",
            "langCode": "en_US"
        }, {
            "id": 4183,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/BIM-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4183,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/BIM-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4184,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Legal-Compliance-Managers",
            "langCode": "en_US"
        }, {
            "id": 4184,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Legal-Compliance-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4184,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Legal-Compliance-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4185,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Agency-Managers",
            "langCode": "en_US"
        }, {
            "id": 4185,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Agency-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4185,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Agency-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4186,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Investment-Advisory-Services-Managers",
            "langCode": "en_US"
        }, {
            "id": 4186,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Investment-Advisory-Services-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4186,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Investment-Advisory-Services-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4187,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Information-Communications-Managers",
            "langCode": "en_US"
        }, {
            "id": 4187,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Information-Communications-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4187,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Information-Communications-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4188,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Child-Care-Centre-Managers",
            "langCode": "en_US"
        }, {
            "id": 4188,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Child-Care-Centre-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4188,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Child-Care-Centre-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4189,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Health-Services-Managers",
            "langCode": "en_US"
        }, {
            "id": 4189,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Health-Services-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4189,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Health-Services-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4190,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Elderly-Home-Managers",
            "langCode": "en_US"
        }, {
            "id": 4190,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Elderly-Home-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4190,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Elderly-Home-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4191,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Social-Services-Organisation-Managers",
            "langCode": "en_US"
        }, {
            "id": 4191,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Social-Services-Organisation-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4191,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Social-Services-Organisation-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4192,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Education-Institution-Managers",
            "langCode": "en_US"
        }, {
            "id": 4192,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Education-Institution-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4192,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Education-Institution-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4193,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Sports-Recreation-Cultural-Managers",
            "langCode": "en_US"
        }, {
            "id": 4193,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Sports-Recreation-Cultural-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4193,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Sports-Recreation-Cultural-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4194,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Front-Office-Managers",
            "langCode": "en_US"
        }, {
            "id": 4194,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Front-Office-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4194,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Front-Office-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4195,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Food-Beverage-Managers",
            "langCode": "en_US"
        }, {
            "id": 4195,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Food-Beverage-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4195,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Food-Beverage-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4196,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Estate-Property-Managers",
            "langCode": "en_US"
        }, {
            "id": 4196,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Estate-Property-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4196,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Estate-Property-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4197,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Transport-Logistic-Managers",
            "langCode": "en_US"
        }, {
            "id": 4197,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Transport-Logistic-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4197,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Transport-Logistic-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4198,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Cargo-Operation-Managers-Airline",
            "langCode": "en_US"
        }, {
            "id": 4198,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Cargo-Operation-Managers-Airline",
            "langCode": "zh_HK"
        }, {
            "id": 4198,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Cargo-Operation-Managers-Airline",
            "langCode": "zh_CN"
        }, {
            "id": 4199,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Ground-Operation-Managers-Airline",
            "langCode": "en_US"
        }, {
            "id": 4199,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Ground-Operation-Managers-Airline",
            "langCode": "zh_HK"
        }, {
            "id": 4199,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Ground-Operation-Managers-Airline",
            "langCode": "zh_CN"
        }, {
            "id": 4200,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Physicists-Meteorologists",
            "langCode": "en_US"
        }, {
            "id": 4200,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Physicists-Meteorologists",
            "langCode": "zh_HK"
        }, {
            "id": 4200,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Physicists-Meteorologists",
            "langCode": "zh_CN"
        }, {
            "id": 4201,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Chemists",
            "langCode": "en_US"
        }, {
            "id": 4201,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Chemists",
            "langCode": "zh_HK"
        }, {
            "id": 4201,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Chemists",
            "langCode": "zh_CN"
        }, {
            "id": 4202,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Statisticians",
            "langCode": "en_US"
        }, {
            "id": 4202,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Statisticians",
            "langCode": "zh_HK"
        }, {
            "id": 4202,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Statisticians",
            "langCode": "zh_CN"
        }, {
            "id": 4203,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Agricultural-Forestry-Professionals",
            "langCode": "en_US"
        }, {
            "id": 4203,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Agricultural-Forestry-Professionals",
            "langCode": "zh_HK"
        }, {
            "id": 4203,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Agricultural-Forestry-Professionals",
            "langCode": "zh_CN"
        }, {
            "id": 4204,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Fisheries-Professionals",
            "langCode": "en_US"
        }, {
            "id": 4204,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Fisheries-Professionals",
            "langCode": "zh_HK"
        }, {
            "id": 4204,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Fisheries-Professionals",
            "langCode": "zh_CN"
        }, {
            "id": 4205,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Environmental-Professionals",
            "langCode": "en_US"
        }, {
            "id": 4205,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Environmental-Professionals",
            "langCode": "zh_HK"
        }, {
            "id": 4205,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Environmental-Professionals",
            "langCode": "zh_CN"
        }, {
            "id": 4206,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Civil-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4206,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Civil-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4206,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Civil-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4207,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Structural-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4207,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Structural-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4207,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Structural-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4208,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Geotechnical-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4208,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Geotechnical-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4208,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Geotechnical-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4209,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Building-Services-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4209,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Building-Services-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4209,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Building-Services-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4210,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Environmental-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4210,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Environmental-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4210,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Environmental-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4211,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/BIM-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4211,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/BIM-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4211,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/BIM-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4212,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Mechanical-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4212,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Mechanical-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4212,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Mechanical-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4213,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Chemical-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4213,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Chemical-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4213,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Chemical-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4214,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Manufacturing-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4214,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Manufacturing-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4214,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Manufacturing-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4215,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Aircraft-Maintenance-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4215,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Aircraft-Maintenance-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4215,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Aircraft-Maintenance-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4217,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Electrical-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4217,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Electrical-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4217,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Electrical-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4218,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Electronics-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4218,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Electronics-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4218,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Electronics-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4219,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Telecommunications-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4219,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Telecommunications-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4219,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Telecommunications-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4220,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Architects",
            "langCode": "en_US"
        }, {
            "id": 4220,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Architects",
            "langCode": "zh_HK"
        }, {
            "id": 4220,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Architects",
            "langCode": "zh_CN"
        }, {
            "id": 4221,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Landscape-Architects",
            "langCode": "en_US"
        }, {
            "id": 4221,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Landscape-Architects",
            "langCode": "zh_HK"
        }, {
            "id": 4221,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Landscape-Architects",
            "langCode": "zh_CN"
        }, {
            "id": 4222,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Town-Planners",
            "langCode": "en_US"
        }, {
            "id": 4222,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Town-Planners",
            "langCode": "zh_HK"
        }, {
            "id": 4222,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Town-Planners",
            "langCode": "zh_CN"
        }, {
            "id": 4223,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Arborists",
            "langCode": "en_US"
        }, {
            "id": 4223,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Arborists",
            "langCode": "zh_HK"
        }, {
            "id": 4223,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Arborists",
            "langCode": "zh_CN"
        }, {
            "id": 4224,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Interior-Designers",
            "langCode": "en_US"
        }, {
            "id": 4224,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Interior-Designers",
            "langCode": "zh_HK"
        }, {
            "id": 4224,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Interior-Designers",
            "langCode": "zh_CN"
        }, {
            "id": 4225,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Graphic-Media-Designers",
            "langCode": "en_US"
        }, {
            "id": 4225,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Graphic-Media-Designers",
            "langCode": "zh_HK"
        }, {
            "id": 4225,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Graphic-Media-Designers",
            "langCode": "zh_CN"
        }, {
            "id": 4226,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Fashion-Designers",
            "langCode": "en_US"
        }, {
            "id": 4226,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Fashion-Designers",
            "langCode": "zh_HK"
        }, {
            "id": 4226,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Fashion-Designers",
            "langCode": "zh_CN"
        }, {
            "id": 4227,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Product-Designers",
            "langCode": "en_US"
        }, {
            "id": 4227,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Product-Designers",
            "langCode": "zh_HK"
        }, {
            "id": 4227,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Product-Designers",
            "langCode": "zh_CN"
        }, {
            "id": 4228,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Medical-Doctors",
            "langCode": "en_US"
        }, {
            "id": 4228,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Medical-Doctors",
            "langCode": "zh_HK"
        }, {
            "id": 4228,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Medical-Doctors",
            "langCode": "zh_CN"
        }, {
            "id": 4229,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Nurses",
            "langCode": "en_US"
        }, {
            "id": 4229,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Nurses",
            "langCode": "zh_HK"
        }, {
            "id": 4229,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Nurses",
            "langCode": "zh_CN"
        }, {
            "id": 4230,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Dentists",
            "langCode": "en_US"
        }, {
            "id": 4230,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Dentists",
            "langCode": "zh_HK"
        }, {
            "id": 4230,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Dentists",
            "langCode": "zh_CN"
        }, {
            "id": 4231,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Chinese-Medicine-Practitioners",
            "langCode": "en_US"
        }, {
            "id": 4231,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Chinese-Medicine-Practitioners",
            "langCode": "zh_HK"
        }, {
            "id": 4231,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Chinese-Medicine-Practitioners",
            "langCode": "zh_CN"
        }, {
            "id": 4232,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Veterinarians",
            "langCode": "en_US"
        }, {
            "id": 4232,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Veterinarians",
            "langCode": "zh_HK"
        }, {
            "id": 4232,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Veterinarians",
            "langCode": "zh_CN"
        }, {
            "id": 4233,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Pharmacists",
            "langCode": "en_US"
        }, {
            "id": 4233,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Pharmacists",
            "langCode": "zh_HK"
        }, {
            "id": 4233,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Pharmacists",
            "langCode": "zh_CN"
        }, {
            "id": 4234,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Psychologists",
            "langCode": "en_US"
        }, {
            "id": 4234,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Psychologists",
            "langCode": "zh_HK"
        }, {
            "id": 4234,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Psychologists",
            "langCode": "zh_CN"
        }, {
            "id": 4235,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Physiotherapists",
            "langCode": "en_US"
        }, {
            "id": 4235,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Physiotherapists",
            "langCode": "zh_HK"
        }, {
            "id": 4235,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Physiotherapists",
            "langCode": "zh_CN"
        }, {
            "id": 4236,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Dietitians-Nutritionists",
            "langCode": "en_US"
        }, {
            "id": 4236,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Dietitians-Nutritionists",
            "langCode": "zh_HK"
        }, {
            "id": 4236,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Dietitians-Nutritionists",
            "langCode": "zh_CN"
        }, {
            "id": 4237,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Speech-Therapists",
            "langCode": "en_US"
        }, {
            "id": 4237,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Speech-Therapists",
            "langCode": "zh_HK"
        }, {
            "id": 4237,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Speech-Therapists",
            "langCode": "zh_CN"
        }, {
            "id": 4238,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Occupational-Therapists",
            "langCode": "en_US"
        }, {
            "id": 4238,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Occupational-Therapists",
            "langCode": "zh_HK"
        }, {
            "id": 4238,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Occupational-Therapists",
            "langCode": "zh_CN"
        }, {
            "id": 4240,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Medical-Laboratory-Technologists",
            "langCode": "en_US"
        }, {
            "id": 4240,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Medical-Laboratory-Technologists",
            "langCode": "zh_HK"
        }, {
            "id": 4240,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Medical-Laboratory-Technologists",
            "langCode": "zh_CN"
        }, {
            "id": 4241,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Optometrists",
            "langCode": "en_US"
        }, {
            "id": 4241,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Optometrists",
            "langCode": "zh_HK"
        }, {
            "id": 4241,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Optometrists",
            "langCode": "zh_CN"
        }, {
            "id": 4242,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Medical-Technology-Consultants",
            "langCode": "en_US"
        }, {
            "id": 4242,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Medical-Technology-Consultants",
            "langCode": "zh_HK"
        }, {
            "id": 4242,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Medical-Technology-Consultants",
            "langCode": "zh_CN"
        }, {
            "id": 4243,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Radiographers",
            "langCode": "en_US"
        }, {
            "id": 4243,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Radiographers",
            "langCode": "zh_HK"
        }, {
            "id": 4243,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Radiographers",
            "langCode": "zh_CN"
        }, {
            "id": 4246,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Secondary-School-Teachers",
            "langCode": "en_US"
        }, {
            "id": 4246,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Secondary-School-Teachers",
            "langCode": "zh_HK"
        }, {
            "id": 4246,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Secondary-School-Teachers",
            "langCode": "zh_CN"
        }, {
            "id": 4247,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Primary-School-Teachers",
            "langCode": "en_US"
        }, {
            "id": 4247,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Primary-School-Teachers",
            "langCode": "zh_HK"
        }, {
            "id": 4247,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Primary-School-Teachers",
            "langCode": "zh_CN"
        }, {
            "id": 4248,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Kindergarten-Teachers",
            "langCode": "en_US"
        }, {
            "id": 4248,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Kindergarten-Teachers",
            "langCode": "zh_HK"
        }, {
            "id": 4248,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Kindergarten-Teachers",
            "langCode": "zh_CN"
        }, {
            "id": 4249,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Special-Education-Teachers",
            "langCode": "en_US"
        }, {
            "id": 4249,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Special-Education-Teachers",
            "langCode": "zh_HK"
        }, {
            "id": 4249,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Special-Education-Teachers",
            "langCode": "zh_CN"
        }, {
            "id": 4250,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Tuition-School-Teachers",
            "langCode": "en_US"
        }, {
            "id": 4250,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Tuition-School-Teachers",
            "langCode": "zh_HK"
        }, {
            "id": 4250,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Tuition-School-Teachers",
            "langCode": "zh_CN"
        }, {
            "id": 4251,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Education-School-Administrators",
            "langCode": "en_US"
        }, {
            "id": 4251,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Education-School-Administrators",
            "langCode": "zh_HK"
        }, {
            "id": 4251,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Education-School-Administrators",
            "langCode": "zh_CN"
        }, {
            "id": 4252,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Financial-Adviser-Representatives",
            "langCode": "en_US"
        }, {
            "id": 4252,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Financial-Adviser-Representatives",
            "langCode": "zh_HK"
        }, {
            "id": 4252,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Financial-Adviser-Representatives",
            "langCode": "zh_CN"
        }, {
            "id": 4253,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Bank-Officers-Executives",
            "langCode": "en_US"
        }, {
            "id": 4253,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Bank-Officers-Executives",
            "langCode": "zh_HK"
        }, {
            "id": 4253,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Bank-Officers-Executives",
            "langCode": "zh_CN"
        }, {
            "id": 4254,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Quantitative-Analysts",
            "langCode": "en_US"
        }, {
            "id": 4254,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Quantitative-Analysts",
            "langCode": "zh_HK"
        }, {
            "id": 4254,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Quantitative-Analysts",
            "langCode": "zh_CN"
        }, {
            "id": 4255,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Business-Management-Consultants",
            "langCode": "en_US"
        }, {
            "id": 4255,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Business-Management-Consultants",
            "langCode": "zh_HK"
        }, {
            "id": 4255,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Business-Management-Consultants",
            "langCode": "zh_CN"
        }, {
            "id": 4256,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Human-Resources-Consultants",
            "langCode": "en_US"
        }, {
            "id": 4256,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Human-Resources-Consultants",
            "langCode": "zh_HK"
        }, {
            "id": 4256,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Human-Resources-Consultants",
            "langCode": "zh_CN"
        }, {
            "id": 4257,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Company-Secretaries",
            "langCode": "en_US"
        }, {
            "id": 4257,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Company-Secretaries",
            "langCode": "zh_HK"
        }, {
            "id": 4257,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Company-Secretaries",
            "langCode": "zh_CN"
        }, {
            "id": 4258,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Advertising-Promotion-Consultants",
            "langCode": "en_US"
        }, {
            "id": 4258,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Advertising-Promotion-Consultants",
            "langCode": "zh_HK"
        }, {
            "id": 4258,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Advertising-Promotion-Consultants",
            "langCode": "zh_CN"
        }, {
            "id": 4259,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Public-Relations-Consultants",
            "langCode": "en_US"
        }, {
            "id": 4259,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Public-Relations-Consultants",
            "langCode": "zh_HK"
        }, {
            "id": 4259,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Public-Relations-Consultants",
            "langCode": "zh_CN"
        }, {
            "id": 4260,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Systems-Analysts",
            "langCode": "en_US"
        }, {
            "id": 4260,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Systems-Analysts",
            "langCode": "zh_HK"
        }, {
            "id": 4260,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Systems-Analysts",
            "langCode": "zh_CN"
        }, {
            "id": 4261,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Programmers-Software-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4261,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Programmers-Software-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4261,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Programmers-Software-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4262,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Web-eCommerce-Developers",
            "langCode": "en_US"
        }, {
            "id": 4262,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Web-eCommerce-Developers",
            "langCode": "zh_HK"
        }, {
            "id": 4262,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Web-eCommerce-Developers",
            "langCode": "zh_CN"
        }, {
            "id": 4263,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Mobile-Phone-Programmers",
            "langCode": "en_US"
        }, {
            "id": 4263,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Mobile-Phone-Programmers",
            "langCode": "zh_HK"
        }, {
            "id": 4263,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Mobile-Phone-Programmers",
            "langCode": "zh_CN"
        }, {
            "id": 4264,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Database-Administrators",
            "langCode": "en_US"
        }, {
            "id": 4264,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Database-Administrators",
            "langCode": "zh_HK"
        }, {
            "id": 4264,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Database-Administrators",
            "langCode": "zh_CN"
        }, {
            "id": 4265,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Systems-Administrators",
            "langCode": "en_US"
        }, {
            "id": 4265,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Systems-Administrators",
            "langCode": "zh_HK"
        }, {
            "id": 4265,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Systems-Administrators",
            "langCode": "zh_CN"
        }, {
            "id": 4266,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Network-Engineers-Specialists",
            "langCode": "en_US"
        }, {
            "id": 4266,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Network-Engineers-Specialists",
            "langCode": "zh_HK"
        }, {
            "id": 4266,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Network-Engineers-Specialists",
            "langCode": "zh_CN"
        }, {
            "id": 4267,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Information-Security-Specialists",
            "langCode": "en_US"
        }, {
            "id": 4267,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Information-Security-Specialists",
            "langCode": "zh_HK"
        }, {
            "id": 4267,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Information-Security-Specialists",
            "langCode": "zh_CN"
        }, {
            "id": 4268,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Information-Technology-Consultants",
            "langCode": "en_US"
        }, {
            "id": 4268,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Information-Technology-Consultants",
            "langCode": "zh_HK"
        }, {
            "id": 4268,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Information-Technology-Consultants",
            "langCode": "zh_CN"
        }, {
            "id": 4269,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Executive-Chefs",
            "langCode": "en_US"
        }, {
            "id": 4269,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Executive-Chefs",
            "langCode": "zh_HK"
        }, {
            "id": 4269,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Executive-Chefs",
            "langCode": "zh_CN"
        }, {
            "id": 4270,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Sommeliers",
            "langCode": "en_US"
        }, {
            "id": 4270,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Sommeliers",
            "langCode": "zh_HK"
        }, {
            "id": 4270,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Sommeliers",
            "langCode": "zh_CN"
        }, {
            "id": 4279,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Average-Adjusters-Maritime",
            "langCode": "en_US"
        }, {
            "id": 4279,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Average-Adjusters-Maritime",
            "langCode": "zh_HK"
        }, {
            "id": 4279,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Average-Adjusters-Maritime",
            "langCode": "zh_CN"
        }, {
            "id": 4282,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Marine-Insurance-Underwriters-Maritime",
            "langCode": "en_US"
        }, {
            "id": 4282,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Marine-Insurance-Underwriters-Maritime",
            "langCode": "zh_HK"
        }, {
            "id": 4282,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Marine-Insurance-Underwriters-Maritime",
            "langCode": "zh_CN"
        }, {
            "id": 4283,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Marine-Insurance-Claims-Executives-Maritime",
            "langCode": "en_US"
        }, {
            "id": 4283,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Marine-Insurance-Claims-Executives-Maritime",
            "langCode": "zh_HK"
        }, {
            "id": 4283,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Marine-Insurance-Claims-Executives-Maritime",
            "langCode": "zh_CN"
        }, {
            "id": 4284,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Aircraft-Pilots",
            "langCode": "en_US"
        }, {
            "id": 4284,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Aircraft-Pilots",
            "langCode": "zh_HK"
        }, {
            "id": 4284,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Aircraft-Pilots",
            "langCode": "zh_CN"
        }, {
            "id": 4287,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Marine-Officers-Maritime",
            "langCode": "en_US"
        }, {
            "id": 4287,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Marine-Officers-Maritime",
            "langCode": "zh_HK"
        }, {
            "id": 4287,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Marine-Officers-Maritime",
            "langCode": "zh_CN"
        }, {
            "id": 4288,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Shipping-Safety-Officers-Maritime",
            "langCode": "en_US"
        }, {
            "id": 4288,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Shipping-Safety-Officers-Maritime",
            "langCode": "zh_HK"
        }, {
            "id": 4288,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Shipping-Safety-Officers-Maritime",
            "langCode": "zh_CN"
        }, {
            "id": 4289,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Surveyors-of-Ships-Maritime",
            "langCode": "en_US"
        }, {
            "id": 4289,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Surveyors-of-Ships-Maritime",
            "langCode": "zh_HK"
        }, {
            "id": 4289,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Surveyors-of-Ships-Maritime",
            "langCode": "zh_CN"
        }, {
            "id": 4290,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Lawyers",
            "langCode": "en_US"
        }, {
            "id": 4290,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Lawyers",
            "langCode": "zh_HK"
        }, {
            "id": 4290,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Lawyers",
            "langCode": "zh_CN"
        }, {
            "id": 4292,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Public-Prosecutors",
            "langCode": "en_US"
        }, {
            "id": 4292,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Public-Prosecutors",
            "langCode": "zh_HK"
        }, {
            "id": 4292,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Public-Prosecutors",
            "langCode": "zh_CN"
        }, {
            "id": 4293,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Maritime-Lawyers-Maritime",
            "langCode": "en_US"
        }, {
            "id": 4293,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Maritime-Lawyers-Maritime",
            "langCode": "zh_HK"
        }, {
            "id": 4293,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Maritime-Lawyers-Maritime",
            "langCode": "zh_CN"
        }, {
            "id": 4294,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Arbitrators",
            "langCode": "en_US"
        }, {
            "id": 4294,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Arbitrators",
            "langCode": "zh_HK"
        }, {
            "id": 4294,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Arbitrators",
            "langCode": "zh_CN"
        }, {
            "id": 4295,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Mediators",
            "langCode": "en_US"
        }, {
            "id": 4295,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Mediators",
            "langCode": "zh_HK"
        }, {
            "id": 4295,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Mediators",
            "langCode": "zh_CN"
        }, {
            "id": 4296,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Curators-Cultural-Managers",
            "langCode": "en_US"
        }, {
            "id": 4296,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Curators-Cultural-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4296,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Curators-Cultural-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4297,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Librarians",
            "langCode": "en_US"
        }, {
            "id": 4297,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Librarians",
            "langCode": "zh_HK"
        }, {
            "id": 4297,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Librarians",
            "langCode": "zh_CN"
        }, {
            "id": 4298,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Writers",
            "langCode": "en_US"
        }, {
            "id": 4298,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Writers",
            "langCode": "zh_HK"
        }, {
            "id": 4298,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Writers",
            "langCode": "zh_CN"
        }, {
            "id": 4299,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Reporters",
            "langCode": "en_US"
        }, {
            "id": 4299,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Reporters",
            "langCode": "zh_HK"
        }, {
            "id": 4299,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Reporters",
            "langCode": "zh_CN"
        }, {
            "id": 4300,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Interpreters",
            "langCode": "en_US"
        }, {
            "id": 4300,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Interpreters",
            "langCode": "zh_HK"
        }, {
            "id": 4300,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Interpreters",
            "langCode": "zh_CN"
        }, {
            "id": 4301,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Visual-Artists",
            "langCode": "en_US"
        }, {
            "id": 4301,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Visual-Artists",
            "langCode": "zh_HK"
        }, {
            "id": 4301,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Visual-Artists",
            "langCode": "zh_CN"
        }, {
            "id": 4302,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Musicians",
            "langCode": "en_US"
        }, {
            "id": 4302,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Musicians",
            "langCode": "zh_HK"
        }, {
            "id": 4302,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Musicians",
            "langCode": "zh_CN"
        }, {
            "id": 4303,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Dancers",
            "langCode": "en_US"
        }, {
            "id": 4303,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Dancers",
            "langCode": "zh_HK"
        }, {
            "id": 4303,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Dancers",
            "langCode": "zh_CN"
        }, {
            "id": 4304,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Producers-Directors",
            "langCode": "en_US"
        }, {
            "id": 4304,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Producers-Directors",
            "langCode": "zh_HK"
        }, {
            "id": 4304,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Producers-Directors",
            "langCode": "zh_CN"
        }, {
            "id": 4305,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Actors",
            "langCode": "en_US"
        }, {
            "id": 4305,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Actors",
            "langCode": "zh_HK"
        }, {
            "id": 4305,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Actors",
            "langCode": "zh_CN"
        }, {
            "id": 4306,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Media-Presenters-News-Anchor-Announcer",
            "langCode": "en_US"
        }, {
            "id": 4306,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Media-Presenters-News-Anchor-Announcer",
            "langCode": "zh_HK"
        }, {
            "id": 4306,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Media-Presenters-News-Anchor-Announcer",
            "langCode": "zh_CN"
        }, {
            "id": 4307,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Fashion-Models",
            "langCode": "en_US"
        }, {
            "id": 4307,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Fashion-Models",
            "langCode": "zh_HK"
        }, {
            "id": 4307,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Fashion-Models",
            "langCode": "zh_CN"
        }, {
            "id": 4308,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Economists",
            "langCode": "en_US"
        }, {
            "id": 4308,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Economists",
            "langCode": "zh_HK"
        }, {
            "id": 4308,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Economists",
            "langCode": "zh_CN"
        }, {
            "id": 4309,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Social-Workers",
            "langCode": "en_US"
        }, {
            "id": 4309,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Social-Workers",
            "langCode": "zh_HK"
        }, {
            "id": 4309,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Social-Workers",
            "langCode": "zh_CN"
        }, {
            "id": 4310,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Religious-Professionals",
            "langCode": "en_US"
        }, {
            "id": 4310,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Religious-Professionals",
            "langCode": "zh_HK"
        }, {
            "id": 4310,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Religious-Professionals",
            "langCode": "zh_CN"
        }, {
            "id": 4311,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Executive-Officers",
            "langCode": "en_US"
        }, {
            "id": 4311,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Executive-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4311,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Executive-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4312,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Trade-Officers",
            "langCode": "en_US"
        }, {
            "id": 4312,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Trade-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4312,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Trade-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4313,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Labour-Officers",
            "langCode": "en_US"
        }, {
            "id": 4313,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Labour-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4313,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Labour-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4314,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Transport-Officers",
            "langCode": "en_US"
        }, {
            "id": 4314,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Transport-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4314,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Transport-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4315,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Official-Languages-Officers",
            "langCode": "en_US"
        }, {
            "id": 4315,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Official-Languages-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4315,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Official-Languages-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4316,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Simultaneous-Interpreters",
            "langCode": "en_US"
        }, {
            "id": 4316,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Simultaneous-Interpreters",
            "langCode": "zh_HK"
        }, {
            "id": 4316,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Simultaneous-Interpreters",
            "langCode": "zh_CN"
        }, {
            "id": 4317,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Customs-Excise-Inspectors",
            "langCode": "en_US"
        }, {
            "id": 4317,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Customs-Excise-Inspectors",
            "langCode": "zh_HK"
        }, {
            "id": 4317,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Customs-Excise-Inspectors",
            "langCode": "zh_CN"
        }, {
            "id": 4318,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Immigration-Officers",
            "langCode": "en_US"
        }, {
            "id": 4318,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Immigration-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4318,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Immigration-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4319,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Fire-Station-Officers",
            "langCode": "en_US"
        }, {
            "id": 4319,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Fire-Station-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4319,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Fire-Station-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4320,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Correctional-Officers",
            "langCode": "en_US"
        }, {
            "id": 4320,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Correctional-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4320,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Correctional-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4321,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Police-Inspectors",
            "langCode": "en_US"
        }, {
            "id": 4321,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Police-Inspectors",
            "langCode": "zh_HK"
        }, {
            "id": 4321,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Police-Inspectors",
            "langCode": "zh_CN"
        }, {
            "id": 4322,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/ICAC-Officers",
            "langCode": "en_US"
        }, {
            "id": 4322,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/ICAC-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4322,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/ICAC-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4323,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Laboratory-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4323,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Laboratory-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4323,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Laboratory-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4324,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Statistical-Officers",
            "langCode": "en_US"
        }, {
            "id": 4324,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Statistical-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4324,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Statistical-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4325,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Agricultural-Forestry-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4325,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Agricultural-Forestry-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4325,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Agricultural-Forestry-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4326,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Fishery-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4326,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Fishery-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4326,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Fishery-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4327,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Civil-Engineering-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4327,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Civil-Engineering-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4327,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Civil-Engineering-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4328,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Structural-Engineering-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4328,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Structural-Engineering-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4328,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Structural-Engineering-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4329,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Geotechnical-Engineering-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4329,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Geotechnical-Engineering-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4329,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Geotechnical-Engineering-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4330,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Building-Services-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4330,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Building-Services-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4330,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Building-Services-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4332,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Clerks-of-Works",
            "langCode": "en_US"
        }, {
            "id": 4332,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Clerks-of-Works",
            "langCode": "zh_HK"
        }, {
            "id": 4332,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Clerks-of-Works",
            "langCode": "zh_CN"
        }, {
            "id": 4336,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Mechanical-Engineering-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4336,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Mechanical-Engineering-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4336,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Mechanical-Engineering-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4337,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Chemical-Engineering-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4337,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Chemical-Engineering-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4337,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Chemical-Engineering-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4339,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Aircraft-Maintenance-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4339,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Aircraft-Maintenance-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4339,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Aircraft-Maintenance-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4340,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Electrical-Engineering-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4340,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Electrical-Engineering-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4340,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Electrical-Engineering-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4341,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Electronics-Engineering-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4341,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Electronics-Engineering-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4341,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Electronics-Engineering-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4342,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Telecommunications-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4342,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Telecommunications-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4342,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Telecommunications-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4344,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Landscape-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4344,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Landscape-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4344,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Landscape-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4345,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Surveying-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4345,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Surveying-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4345,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Surveying-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4346,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Safety-Officers",
            "langCode": "en_US"
        }, {
            "id": 4346,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Safety-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4346,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Safety-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4347,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/BIM-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4347,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/BIM-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4347,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/BIM-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4350,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Dental-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4350,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Dental-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4350,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Dental-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4352,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Health-Inspectors",
            "langCode": "en_US"
        }, {
            "id": 4352,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Health-Inspectors",
            "langCode": "zh_HK"
        }, {
            "id": 4352,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Health-Inspectors",
            "langCode": "zh_CN"
        }, {
            "id": 4354,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Environmental-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4354,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Environmental-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4354,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Environmental-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4355,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Environmental-Protection-Inspectors",
            "langCode": "en_US"
        }, {
            "id": 4355,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Environmental-Protection-Inspectors",
            "langCode": "zh_HK"
        }, {
            "id": 4355,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Environmental-Protection-Inspectors",
            "langCode": "zh_CN"
        }, {
            "id": 4356,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Investment-Services-Dealers",
            "langCode": "en_US"
        }, {
            "id": 4356,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Investment-Services-Dealers",
            "langCode": "zh_HK"
        }, {
            "id": 4356,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Investment-Services-Dealers",
            "langCode": "zh_CN"
        }, {
            "id": 4357,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Credit-Analysts",
            "langCode": "en_US"
        }, {
            "id": 4357,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Credit-Analysts",
            "langCode": "zh_HK"
        }, {
            "id": 4357,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Credit-Analysts",
            "langCode": "zh_CN"
        }, {
            "id": 4358,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Accounting-Supervisors",
            "langCode": "en_US"
        }, {
            "id": 4358,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Accounting-Supervisors",
            "langCode": "zh_HK"
        }, {
            "id": 4358,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Accounting-Supervisors",
            "langCode": "zh_CN"
        }, {
            "id": 4359,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Audit-Associates",
            "langCode": "en_US"
        }, {
            "id": 4359,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Audit-Associates",
            "langCode": "zh_HK"
        }, {
            "id": 4359,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Audit-Associates",
            "langCode": "zh_CN"
        }, {
            "id": 4360,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Valuation-Officers",
            "langCode": "en_US"
        }, {
            "id": 4360,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Valuation-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4360,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Valuation-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4361,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Insurance-Agents",
            "langCode": "en_US"
        }, {
            "id": 4361,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Insurance-Agents",
            "langCode": "zh_HK"
        }, {
            "id": 4361,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Insurance-Agents",
            "langCode": "zh_CN"
        }, {
            "id": 4362,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Transport-Logistic-Executives",
            "langCode": "en_US"
        }, {
            "id": 4362,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Transport-Logistic-Executives",
            "langCode": "zh_HK"
        }, {
            "id": 4362,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Transport-Logistic-Executives",
            "langCode": "zh_CN"
        }, {
            "id": 4363,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Administrative-Assistants",
            "langCode": "en_US"
        }, {
            "id": 4363,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Administrative-Assistants",
            "langCode": "zh_HK"
        }, {
            "id": 4363,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Administrative-Assistants",
            "langCode": "zh_CN"
        }, {
            "id": 4364,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Public-Relations-Officers",
            "langCode": "en_US"
        }, {
            "id": 4364,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Public-Relations-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4364,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Public-Relations-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4365,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Customer-Service-Executives",
            "langCode": "en_US"
        }, {
            "id": 4365,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Customer-Service-Executives",
            "langCode": "zh_HK"
        }, {
            "id": 4365,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Customer-Service-Executives",
            "langCode": "zh_CN"
        }, {
            "id": 4366,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Shipping-Agents",
            "langCode": "en_US"
        }, {
            "id": 4366,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Shipping-Agents",
            "langCode": "zh_HK"
        }, {
            "id": 4366,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Shipping-Agents",
            "langCode": "zh_CN"
        }, {
            "id": 4367,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Event-Co-ordinators",
            "langCode": "en_US"
        }, {
            "id": 4367,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Event-Co-ordinators",
            "langCode": "zh_HK"
        }, {
            "id": 4367,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Event-Co-ordinators",
            "langCode": "zh_CN"
        }, {
            "id": 4368,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Employment-Agents",
            "langCode": "en_US"
        }, {
            "id": 4368,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Employment-Agents",
            "langCode": "zh_HK"
        }, {
            "id": 4368,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Employment-Agents",
            "langCode": "zh_CN"
        }, {
            "id": 4369,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Real-Estate-Agents",
            "langCode": "en_US"
        }, {
            "id": 4369,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Real-Estate-Agents",
            "langCode": "zh_HK"
        }, {
            "id": 4369,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Real-Estate-Agents",
            "langCode": "zh_CN"
        }, {
            "id": 4370,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Property-Officers",
            "langCode": "en_US"
        }, {
            "id": 4370,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Property-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4370,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Property-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4371,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Information-Systems-Operators",
            "langCode": "en_US"
        }, {
            "id": 4371,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Information-Systems-Operators",
            "langCode": "zh_HK"
        }, {
            "id": 4371,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Information-Systems-Operators",
            "langCode": "zh_CN"
        }, {
            "id": 4372,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Information-Systems-User-Support",
            "langCode": "en_US"
        }, {
            "id": 4372,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Information-Systems-User-Support",
            "langCode": "zh_HK"
        }, {
            "id": 4372,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Information-Systems-User-Support",
            "langCode": "zh_CN"
        }, {
            "id": 4373,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Network-Administrators",
            "langCode": "en_US"
        }, {
            "id": 4373,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Network-Administrators",
            "langCode": "zh_HK"
        }, {
            "id": 4373,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Network-Administrators",
            "langCode": "zh_CN"
        }, {
            "id": 4374,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Web-Administrators",
            "langCode": "en_US"
        }, {
            "id": 4374,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Web-Administrators",
            "langCode": "zh_HK"
        }, {
            "id": 4374,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Web-Administrators",
            "langCode": "zh_CN"
        }, {
            "id": 4375,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Cooks",
            "langCode": "en_US"
        }, {
            "id": 4375,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Cooks",
            "langCode": "zh_HK"
        }, {
            "id": 4375,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Cooks",
            "langCode": "zh_CN"
        }, {
            "id": 4376,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Bartenders",
            "langCode": "en_US"
        }, {
            "id": 4376,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Bartenders",
            "langCode": "zh_HK"
        }, {
            "id": 4376,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Bartenders",
            "langCode": "zh_CN"
        }, {
            "id": 4379,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Air-Traffic-Officers",
            "langCode": "en_US"
        }, {
            "id": 4379,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Air-Traffic-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4379,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Air-Traffic-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4380,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Flight-Attendants-Pursers",
            "langCode": "en_US"
        }, {
            "id": 4380,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Flight-Attendants-Pursers",
            "langCode": "zh_HK"
        }, {
            "id": 4380,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Flight-Attendants-Pursers",
            "langCode": "zh_CN"
        }, {
            "id": 4381,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Cargo-Handling-Supervisors-Airline",
            "langCode": "en_US"
        }, {
            "id": 4381,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Cargo-Handling-Supervisors-Airline",
            "langCode": "zh_HK"
        }, {
            "id": 4381,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Cargo-Handling-Supervisors-Airline",
            "langCode": "zh_CN"
        }, {
            "id": 4382,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Ground-Operation-Officers-Airline",
            "langCode": "en_US"
        }, {
            "id": 4382,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Ground-Operation-Officers-Airline",
            "langCode": "zh_HK"
        }, {
            "id": 4382,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Ground-Operation-Officers-Airline",
            "langCode": "zh_CN"
        }, {
            "id": 4383,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Airport-Passenger-Services-Officers",
            "langCode": "en_US"
        }, {
            "id": 4383,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Airport-Passenger-Services-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4383,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Airport-Passenger-Services-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4385,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Transport-Inspectors",
            "langCode": "en_US"
        }, {
            "id": 4385,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Transport-Inspectors",
            "langCode": "zh_HK"
        }, {
            "id": 4385,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Transport-Inspectors",
            "langCode": "zh_CN"
        }, {
            "id": 4386,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Marine-Inspectors-II-Maritime",
            "langCode": "en_US"
        }, {
            "id": 4386,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Marine-Inspectors-II-Maritime",
            "langCode": "zh_HK"
        }, {
            "id": 4386,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Marine-Inspectors-II-Maritime",
            "langCode": "zh_CN"
        }, {
            "id": 4387,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Assistant-Ship-Inspectors-Maritime",
            "langCode": "en_US"
        }, {
            "id": 4387,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Assistant-Ship-Inspectors-Maritime",
            "langCode": "zh_HK"
        }, {
            "id": 4387,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Assistant-Ship-Inspectors-Maritime",
            "langCode": "zh_CN"
        }, {
            "id": 4388,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Assistant-Marine-Controllers-Maritime",
            "langCode": "en_US"
        }, {
            "id": 4388,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Assistant-Marine-Controllers-Maritime",
            "langCode": "zh_HK"
        }, {
            "id": 4388,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Assistant-Marine-Controllers-Maritime",
            "langCode": "zh_CN"
        }, {
            "id": 4391,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Stage-Designers",
            "langCode": "en_US"
        }, {
            "id": 4391,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Stage-Designers",
            "langCode": "zh_HK"
        }, {
            "id": 4391,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Stage-Designers",
            "langCode": "zh_CN"
        }, {
            "id": 4392,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Legal-Officers-Paralegals",
            "langCode": "en_US"
        }, {
            "id": 4392,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Legal-Officers-Paralegals",
            "langCode": "zh_HK"
        }, {
            "id": 4392,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Legal-Officers-Paralegals",
            "langCode": "zh_CN"
        }, {
            "id": 4393,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Social-Work-Assistants",
            "langCode": "en_US"
        }, {
            "id": 4393,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Social-Work-Assistants",
            "langCode": "zh_HK"
        }, {
            "id": 4393,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Social-Work-Assistants",
            "langCode": "zh_CN"
        }, {
            "id": 4394,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Hospital-Clinic-Assistants",
            "langCode": "en_US"
        }, {
            "id": 4394,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Hospital-Clinic-Assistants",
            "langCode": "zh_HK"
        }, {
            "id": 4394,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Hospital-Clinic-Assistants",
            "langCode": "zh_CN"
        }, {
            "id": 4395,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Athletes",
            "langCode": "en_US"
        }, {
            "id": 4395,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Athletes",
            "langCode": "zh_HK"
        }, {
            "id": 4395,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Athletes",
            "langCode": "zh_CN"
        }, {
            "id": 4396,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Sports-Fitness-Coaches",
            "langCode": "en_US"
        }, {
            "id": 4396,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Sports-Fitness-Coaches",
            "langCode": "zh_HK"
        }, {
            "id": 4396,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Sports-Fitness-Coaches",
            "langCode": "zh_CN"
        }, {
            "id": 4397,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Photographers",
            "langCode": "en_US"
        }, {
            "id": 4397,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Photographers",
            "langCode": "zh_HK"
        }, {
            "id": 4397,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Photographers",
            "langCode": "zh_CN"
        }, {
            "id": 4398,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Assistant-Librarians",
            "langCode": "en_US"
        }, {
            "id": 4398,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Assistant-Librarians",
            "langCode": "zh_HK"
        }, {
            "id": 4398,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Assistant-Librarians",
            "langCode": "zh_CN"
        }, {
            "id": 4399,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Assistant-Leisure-Cultural-Officers",
            "langCode": "en_US"
        }, {
            "id": 4399,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Assistant-Leisure-Cultural-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4399,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Assistant-Leisure-Cultural-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4400,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Firemen",
            "langCode": "en_US"
        }, {
            "id": 4400,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Firemen",
            "langCode": "zh_HK"
        }, {
            "id": 4400,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Firemen",
            "langCode": "zh_CN"
        }, {
            "id": 4401,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Policemen",
            "langCode": "en_US"
        }, {
            "id": 4401,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Policemen",
            "langCode": "zh_HK"
        }, {
            "id": 4401,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Policemen",
            "langCode": "zh_CN"
        }, {
            "id": 4402,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Assistant-Correctional-Officers-II",
            "langCode": "en_US"
        }, {
            "id": 4402,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Assistant-Correctional-Officers-II",
            "langCode": "zh_HK"
        }, {
            "id": 4402,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Assistant-Correctional-Officers-II",
            "langCode": "zh_CN"
        }, {
            "id": 4403,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Immigration-Assistants",
            "langCode": "en_US"
        }, {
            "id": 4403,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Immigration-Assistants",
            "langCode": "zh_HK"
        }, {
            "id": 4403,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Immigration-Assistants",
            "langCode": "zh_CN"
        }, {
            "id": 4404,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Customs-Excise-Officers",
            "langCode": "en_US"
        }, {
            "id": 4404,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Customs-Excise-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4404,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Customs-Excise-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4405,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Office-Clerks",
            "langCode": "en_US"
        }, {
            "id": 4405,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Office-Clerks",
            "langCode": "zh_HK"
        }, {
            "id": 4405,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Office-Clerks",
            "langCode": "zh_CN"
        }, {
            "id": 4406,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Secretaries",
            "langCode": "en_US"
        }, {
            "id": 4406,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Secretaries",
            "langCode": "zh_HK"
        }, {
            "id": 4406,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Secretaries",
            "langCode": "zh_CN"
        }, {
            "id": 4407,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Personnel-Clerks",
            "langCode": "en_US"
        }, {
            "id": 4407,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Personnel-Clerks",
            "langCode": "zh_HK"
        }, {
            "id": 4407,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Personnel-Clerks",
            "langCode": "zh_CN"
        }, {
            "id": 4408,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Data-Entry-Clerks",
            "langCode": "en_US"
        }, {
            "id": 4408,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Data-Entry-Clerks",
            "langCode": "zh_HK"
        }, {
            "id": 4408,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Data-Entry-Clerks",
            "langCode": "zh_CN"
        }, {
            "id": 4409,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Bank-Tellers",
            "langCode": "en_US"
        }, {
            "id": 4409,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Bank-Tellers",
            "langCode": "zh_HK"
        }, {
            "id": 4409,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Bank-Tellers",
            "langCode": "zh_CN"
        }, {
            "id": 4411,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Receptionists",
            "langCode": "en_US"
        }, {
            "id": 4411,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Receptionists",
            "langCode": "zh_HK"
        }, {
            "id": 4411,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Receptionists",
            "langCode": "zh_CN"
        }, {
            "id": 4412,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Customer-Service-Assistants",
            "langCode": "en_US"
        }, {
            "id": 4412,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Customer-Service-Assistants",
            "langCode": "zh_HK"
        }, {
            "id": 4412,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Customer-Service-Assistants",
            "langCode": "zh_CN"
        }, {
            "id": 4413,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Survey-Interviewers",
            "langCode": "en_US"
        }, {
            "id": 4413,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Survey-Interviewers",
            "langCode": "zh_HK"
        }, {
            "id": 4413,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Survey-Interviewers",
            "langCode": "zh_CN"
        }, {
            "id": 4414,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Accounting-Clerks",
            "langCode": "en_US"
        }, {
            "id": 4414,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Accounting-Clerks",
            "langCode": "zh_HK"
        }, {
            "id": 4414,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Accounting-Clerks",
            "langCode": "zh_CN"
        }, {
            "id": 4416,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Warehouse-Clerks",
            "langCode": "en_US"
        }, {
            "id": 4416,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Warehouse-Clerks",
            "langCode": "zh_HK"
        }, {
            "id": 4416,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Warehouse-Clerks",
            "langCode": "zh_CN"
        }, {
            "id": 4418,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Shipping-Logistics-Clerks",
            "langCode": "en_US"
        }, {
            "id": 4418,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Shipping-Logistics-Clerks",
            "langCode": "zh_HK"
        }, {
            "id": 4418,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Shipping-Logistics-Clerks",
            "langCode": "zh_CN"
        }, {
            "id": 4419,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Tour-Escorts-Outbound",
            "langCode": "en_US"
        }, {
            "id": 4419,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Tour-Escorts-Outbound",
            "langCode": "zh_HK"
        }, {
            "id": 4419,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Tour-Escorts-Outbound",
            "langCode": "zh_CN"
        }, {
            "id": 4421,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Hairdressers",
            "langCode": "en_US"
        }, {
            "id": 4421,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Hairdressers",
            "langCode": "zh_HK"
        }, {
            "id": 4421,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Hairdressers",
            "langCode": "zh_CN"
        }, {
            "id": 4422,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Beauticians",
            "langCode": "en_US"
        }, {
            "id": 4422,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Beauticians",
            "langCode": "zh_HK"
        }, {
            "id": 4422,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Beauticians",
            "langCode": "zh_CN"
        }, {
            "id": 4425,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Pet-Groomers-Animal-Keepers",
            "langCode": "en_US"
        }, {
            "id": 4425,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Pet-Groomers-Animal-Keepers",
            "langCode": "zh_HK"
        }, {
            "id": 4425,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Pet-Groomers-Animal-Keepers",
            "langCode": "zh_CN"
        }, {
            "id": 4426,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Child-Care-Workers",
            "langCode": "en_US"
        }, {
            "id": 4426,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Child-Care-Workers",
            "langCode": "zh_HK"
        }, {
            "id": 4426,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Child-Care-Workers",
            "langCode": "zh_CN"
        }, {
            "id": 4427,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Personal-Care-Workers",
            "langCode": "en_US"
        }, {
            "id": 4427,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Personal-Care-Workers",
            "langCode": "zh_HK"
        }, {
            "id": 4427,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Personal-Care-Workers",
            "langCode": "zh_CN"
        }, {
            "id": 4453,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Aircraft-Maintenance-Mechanics",
            "langCode": "en_US"
        }, {
            "id": 4453,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Aircraft-Maintenance-Mechanics",
            "langCode": "zh_HK"
        }, {
            "id": 4453,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Aircraft-Maintenance-Mechanics",
            "langCode": "zh_CN"
        }, {
            "id": 4455,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Jewellery-Workers",
            "langCode": "en_US"
        }, {
            "id": 4455,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Jewellery-Workers",
            "langCode": "zh_HK"
        }, {
            "id": 4455,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Jewellery-Workers",
            "langCode": "zh_CN"
        }, {
            "id": 4463,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Bakers",
            "langCode": "en_US"
        }, {
            "id": 4463,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Bakers",
            "langCode": "zh_HK"
        }, {
            "id": 4463,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Bakers",
            "langCode": "zh_CN"
        }, {
            "id": 4464,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Tailors-Dressmakers",
            "langCode": "en_US"
        }, {
            "id": 4464,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Tailors-Dressmakers",
            "langCode": "zh_HK"
        }, {
            "id": 4464,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Tailors-Dressmakers",
            "langCode": "zh_CN"
        }, {
            "id": 4476,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Tourist-Guides-Inbound",
            "langCode": "en_US"
        }, {
            "id": 4476,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Tourist-Guides-Inbound",
            "langCode": "zh_HK"
        }, {
            "id": 4476,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Tourist-Guides-Inbound",
            "langCode": "zh_CN"
        }, {
            "id": 4477,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Audit-Seniors",
            "langCode": "en_US"
        }, {
            "id": 4477,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Audit-Seniors",
            "langCode": "zh_HK"
        }, {
            "id": 4477,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Audit-Seniors",
            "langCode": "zh_CN"
        }, {
            "id": 4479,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Tax-Juniors",
            "langCode": "en_US"
        }, {
            "id": 4479,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Tax-Juniors",
            "langCode": "zh_HK"
        }, {
            "id": 4479,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Tax-Juniors",
            "langCode": "zh_CN"
        }, {
            "id": 4480,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Tax-Seniors",
            "langCode": "en_US"
        }, {
            "id": 4480,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Tax-Seniors",
            "langCode": "zh_HK"
        }, {
            "id": 4480,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Tax-Seniors",
            "langCode": "zh_CN"
        }, {
            "id": 4481,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Tax-Managers",
            "langCode": "en_US"
        }, {
            "id": 4481,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Tax-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4481,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Tax-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4483,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Consultants",
            "langCode": "en_US"
        }, {
            "id": 4483,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Consultants",
            "langCode": "zh_HK"
        }, {
            "id": 4483,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Consultants",
            "langCode": "zh_CN"
        }, {
            "id": 4485,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Consultant-Managers",
            "langCode": "en_US"
        }, {
            "id": 4485,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Consultant-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4485,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Consultant-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4487,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Accountants",
            "langCode": "en_US"
        }, {
            "id": 4487,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Accountants",
            "langCode": "zh_HK"
        }, {
            "id": 4487,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Accountants",
            "langCode": "zh_CN"
        }, {
            "id": 4499,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Treasury-and-Capital-Markets-Officers",
            "langCode": "en_US"
        }, {
            "id": 4499,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Treasury-and-Capital-Markets-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4499,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Treasury-and-Capital-Markets-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4500,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Investment-Officers",
            "langCode": "en_US"
        }, {
            "id": 4500,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Investment-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4500,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Investment-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4501,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Investment-Settlement-Officers",
            "langCode": "en_US"
        }, {
            "id": 4501,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Investment-Settlement-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4501,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Investment-Settlement-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4502,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Credit-Management-Managers",
            "langCode": "en_US"
        }, {
            "id": 4502,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Credit-Management-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4502,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Credit-Management-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4503,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Credit-Officers",
            "langCode": "en_US"
        }, {
            "id": 4503,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Credit-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4503,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Credit-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4504,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Branch-Managers",
            "langCode": "en_US"
        }, {
            "id": 4504,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Branch-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4504,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Branch-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4505,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Corporate-Banking-Relationship-Management-Officers",
            "langCode": "en_US"
        }, {
            "id": 4505,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Corporate-Banking-Relationship-Management-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4505,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Corporate-Banking-Relationship-Management-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4506,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Private-Banking-Relationship-Officers",
            "langCode": "en_US"
        }, {
            "id": 4506,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Private-Banking-Relationship-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4506,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Private-Banking-Relationship-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4507,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Personal-Banking-Customer-Services-Officers",
            "langCode": "en_US"
        }, {
            "id": 4507,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Personal-Banking-Customer-Services-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4507,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Personal-Banking-Customer-Services-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4508,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Trade-Finance-Operations-Officers",
            "langCode": "en_US"
        }, {
            "id": 4508,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Trade-Finance-Operations-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4508,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Trade-Finance-Operations-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4509,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Banking-and-Finance-Operation-Officers",
            "langCode": "en_US"
        }, {
            "id": 4509,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Banking-and-Finance-Operation-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4509,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Banking-and-Finance-Operation-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4510,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Anti-Money-Laundering-Officers",
            "langCode": "en_US"
        }, {
            "id": 4510,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Anti-Money-Laundering-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4510,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Anti-Money-Laundering-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4511,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Investment-Analysts",
            "langCode": "en_US"
        }, {
            "id": 4511,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Investment-Analysts",
            "langCode": "zh_HK"
        }, {
            "id": 4511,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Investment-Analysts",
            "langCode": "zh_CN"
        }, {
            "id": 4515,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Beauty-Consultants",
            "langCode": "en_US"
        }, {
            "id": 4515,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Beauty-Consultants",
            "langCode": "zh_HK"
        }, {
            "id": 4515,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Beauty-Consultants",
            "langCode": "zh_CN"
        }, {
            "id": 4518,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Make-up-Artists",
            "langCode": "en_US"
        }, {
            "id": 4518,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Make-up-Artists",
            "langCode": "zh_HK"
        }, {
            "id": 4518,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Make-up-Artists",
            "langCode": "zh_CN"
        }, {
            "id": 4525,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Building-Maintenance-Surveyors",
            "langCode": "en_US"
        }, {
            "id": 4525,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Building-Maintenance-Surveyors",
            "langCode": "zh_HK"
        }, {
            "id": 4525,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Building-Maintenance-Surveyors",
            "langCode": "zh_CN"
        }, {
            "id": 4526,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Land-Surveyors",
            "langCode": "en_US"
        }, {
            "id": 4526,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Land-Surveyors",
            "langCode": "zh_HK"
        }, {
            "id": 4526,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Land-Surveyors",
            "langCode": "zh_CN"
        }, {
            "id": 4527,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Quantity-Surveyors",
            "langCode": "en_US"
        }, {
            "id": 4527,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Quantity-Surveyors",
            "langCode": "zh_HK"
        }, {
            "id": 4527,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Quantity-Surveyors",
            "langCode": "zh_CN"
        }, {
            "id": 4528,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Quality-Assurance-Control-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4528,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Quality-Assurance-Control-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4528,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Quality-Assurance-Control-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4530,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Quality-Assurance-Control-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4530,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Quality-Assurance-Control-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4530,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Quality-Assurance-Control-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4553,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Fire-Services-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4553,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Fire-Services-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4553,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Fire-Services-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4560,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Telecommunications-Consultants",
            "langCode": "en_US"
        }, {
            "id": 4560,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Telecommunications-Consultants",
            "langCode": "zh_HK"
        }, {
            "id": 4560,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Telecommunications-Consultants",
            "langCode": "zh_CN"
        }, {
            "id": 4561,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Data-Centre-Specialists",
            "langCode": "en_US"
        }, {
            "id": 4561,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Data-Centre-Specialists",
            "langCode": "zh_HK"
        }, {
            "id": 4561,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Data-Centre-Specialists",
            "langCode": "zh_CN"
        }, {
            "id": 4562,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Data-Centre-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4562,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Data-Centre-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4562,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Data-Centre-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4563,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/IoT-Solution-Specialists",
            "langCode": "en_US"
        }, {
            "id": 4563,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/IoT-Solution-Specialists",
            "langCode": "zh_HK"
        }, {
            "id": 4563,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/IoT-Solution-Specialists",
            "langCode": "zh_CN"
        }, {
            "id": 4564,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Cloud-Infrastructure-Specialists",
            "langCode": "en_US"
        }, {
            "id": 4564,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Cloud-Infrastructure-Specialists",
            "langCode": "zh_HK"
        }, {
            "id": 4564,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Cloud-Infrastructure-Specialists",
            "langCode": "zh_CN"
        }, {
            "id": 4565,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Fashion-Merchandisers",
            "langCode": "en_US"
        }, {
            "id": 4565,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Fashion-Merchandisers",
            "langCode": "zh_HK"
        }, {
            "id": 4565,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Fashion-Merchandisers",
            "langCode": "zh_CN"
        }, {
            "id": 4566,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Fashion-Merchandising-Managers",
            "langCode": "en_US"
        }, {
            "id": 4566,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Fashion-Merchandising-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4566,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Fashion-Merchandising-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4569,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/CAD-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4569,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/CAD-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4569,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/CAD-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4570,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Laboratory-Managers",
            "langCode": "en_US"
        }, {
            "id": 4570,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Laboratory-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4570,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Laboratory-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4573,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Front-Desk-Agents",
            "langCode": "en_US"
        }, {
            "id": 4573,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Front-Desk-Agents",
            "langCode": "zh_HK"
        }, {
            "id": 4573,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Front-Desk-Agents",
            "langCode": "zh_CN"
        }, {
            "id": 4579,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Travel-Consultants",
            "langCode": "en_US"
        }, {
            "id": 4579,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Travel-Consultants",
            "langCode": "zh_HK"
        }, {
            "id": 4579,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Travel-Consultants",
            "langCode": "zh_CN"
        }, {
            "id": 4580,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Product-Development-Managers",
            "langCode": "en_US"
        }, {
            "id": 4580,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Product-Development-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4580,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Product-Development-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4581,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Shipping-Managers",
            "langCode": "en_US"
        }, {
            "id": 4581,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Shipping-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4581,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Shipping-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4582,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Merchandising-Managers",
            "langCode": "en_US"
        }, {
            "id": 4582,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Merchandising-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4582,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Merchandising-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4583,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Quality-Control-Managers",
            "langCode": "en_US"
        }, {
            "id": 4583,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Quality-Control-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4583,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Quality-Control-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4584,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Sales-Managers",
            "langCode": "en_US"
        }, {
            "id": 4584,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Sales-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4584,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Sales-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4585,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Marketing-Managers",
            "langCode": "en_US"
        }, {
            "id": 4585,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Marketing-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4585,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Marketing-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4586,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Marketing-Executives",
            "langCode": "en_US"
        }, {
            "id": 4586,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Marketing-Executives",
            "langCode": "zh_HK"
        }, {
            "id": 4586,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Marketing-Executives",
            "langCode": "zh_CN"
        }, {
            "id": 4587,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Merchandisers",
            "langCode": "en_US"
        }, {
            "id": 4587,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Merchandisers",
            "langCode": "zh_HK"
        }, {
            "id": 4587,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Merchandisers",
            "langCode": "zh_CN"
        }, {
            "id": 4588,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Quality-Control-Officers",
            "langCode": "en_US"
        }, {
            "id": 4588,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Quality-Control-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4588,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Quality-Control-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4589,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Product-Development-Officers",
            "langCode": "en_US"
        }, {
            "id": 4589,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Product-Development-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4589,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Product-Development-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4591,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Software-Firmware-Product-Designers",
            "langCode": "en_US"
        }, {
            "id": 4591,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Software-Firmware-Product-Designers",
            "langCode": "zh_HK"
        }, {
            "id": 4591,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Software-Firmware-Product-Designers",
            "langCode": "zh_CN"
        }, {
            "id": 4592,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Game-Designers",
            "langCode": "en_US"
        }, {
            "id": 4592,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Game-Designers",
            "langCode": "zh_HK"
        }, {
            "id": 4592,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Game-Designers",
            "langCode": "zh_CN"
        }, {
            "id": 4593,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Data-Scientists",
            "langCode": "en_US"
        }, {
            "id": 4593,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Data-Scientists",
            "langCode": "zh_HK"
        }, {
            "id": 4593,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Data-Scientists",
            "langCode": "zh_CN"
        }, {
            "id": 4594,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Artificial-Intelligence-Specialists",
            "langCode": "en_US"
        }, {
            "id": 4594,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Artificial-Intelligence-Specialists",
            "langCode": "zh_HK"
        }, {
            "id": 4594,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Artificial-Intelligence-Specialists",
            "langCode": "zh_CN"
        }, {
            "id": 4595,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Research-and-Development-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4595,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Research-and-Development-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4595,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Research-and-Development-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4596,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Research-and-Development-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4596,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Research-and-Development-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4596,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Research-and-Development-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4597,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Cloud-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4597,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Cloud-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4597,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Cloud-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4598,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Cloud-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4598,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Cloud-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4598,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Cloud-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4599,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/UX-Designers",
            "langCode": "en_US"
        }, {
            "id": 4599,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/UX-Designers",
            "langCode": "zh_HK"
        }, {
            "id": 4599,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/UX-Designers",
            "langCode": "zh_CN"
        }, {
            "id": 4600,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Storage-Specialists",
            "langCode": "en_US"
        }, {
            "id": 4600,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Storage-Specialists",
            "langCode": "zh_HK"
        }, {
            "id": 4600,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Storage-Specialists",
            "langCode": "zh_CN"
        }, {
            "id": 4601,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Digital-Marketing-Analysts",
            "langCode": "en_US"
        }, {
            "id": 4601,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Digital-Marketing-Analysts",
            "langCode": "zh_HK"
        }, {
            "id": 4601,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Digital-Marketing-Analysts",
            "langCode": "zh_CN"
        }, {
            "id": 4602,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Policy-Services-Managers",
            "langCode": "en_US"
        }, {
            "id": 4602,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Policy-Services-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4602,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Policy-Services-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4603,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Policy-Services-Supervisors",
            "langCode": "en_US"
        }, {
            "id": 4603,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Policy-Services-Supervisors",
            "langCode": "zh_HK"
        }, {
            "id": 4603,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Policy-Services-Supervisors",
            "langCode": "zh_CN"
        }, {
            "id": 4604,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Claims-Managers",
            "langCode": "en_US"
        }, {
            "id": 4604,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Claims-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4604,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Claims-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4605,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Claims-Supervisors",
            "langCode": "en_US"
        }, {
            "id": 4605,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Claims-Supervisors",
            "langCode": "zh_HK"
        }, {
            "id": 4605,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Claims-Supervisors",
            "langCode": "zh_CN"
        }, {
            "id": 4606,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Underwriting-Managers",
            "langCode": "en_US"
        }, {
            "id": 4606,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Underwriting-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4606,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Underwriting-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4607,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Underwriting-Supervisors",
            "langCode": "en_US"
        }, {
            "id": 4607,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Underwriting-Supervisors",
            "langCode": "zh_HK"
        }, {
            "id": 4607,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Underwriting-Supervisors",
            "langCode": "zh_CN"
        }, {
            "id": 4608,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Agency-Administration-Managers",
            "langCode": "en_US"
        }, {
            "id": 4608,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Agency-Administration-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4608,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Agency-Administration-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4609,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Agency-Administration-Supervisors",
            "langCode": "en_US"
        }, {
            "id": 4609,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Agency-Administration-Supervisors",
            "langCode": "zh_HK"
        }, {
            "id": 4609,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Agency-Administration-Supervisors",
            "langCode": "zh_CN"
        }, {
            "id": 4610,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Actuarial-Managers",
            "langCode": "en_US"
        }, {
            "id": 4610,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Actuarial-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4610,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Actuarial-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4611,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Actuarial-Supervisors",
            "langCode": "en_US"
        }, {
            "id": 4611,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Actuarial-Supervisors",
            "langCode": "zh_HK"
        }, {
            "id": 4611,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Actuarial-Supervisors",
            "langCode": "zh_CN"
        }, {
            "id": 4614,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Agency-Supervisors",
            "langCode": "en_US"
        }, {
            "id": 4614,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Agency-Supervisors",
            "langCode": "zh_HK"
        }, {
            "id": 4614,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Agency-Supervisors",
            "langCode": "zh_CN"
        }, {
            "id": 4628,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Compliance-Managers",
            "langCode": "en_US"
        }, {
            "id": 4628,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Compliance-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4628,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Compliance-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4629,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Compliance-Officers",
            "langCode": "en_US"
        }, {
            "id": 4629,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Compliance-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4629,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Compliance-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4630,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Risk-Managers",
            "langCode": "en_US"
        }, {
            "id": 4630,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Risk-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4630,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Risk-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4631,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Project-Managers",
            "langCode": "en_US"
        }, {
            "id": 4631,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Project-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4631,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Project-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4632,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Technical-Sales-Marketing-Executives",
            "langCode": "en_US"
        }, {
            "id": 4632,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Technical-Sales-Marketing-Executives",
            "langCode": "zh_HK"
        }, {
            "id": 4632,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Technical-Sales-Marketing-Executives",
            "langCode": "zh_CN"
        }, {
            "id": 4634,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Technical-Sales-Marketing-Managers",
            "langCode": "en_US"
        }, {
            "id": 4634,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Technical-Sales-Marketing-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4634,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Technical-Sales-Marketing-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4635,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Product-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4635,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Product-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4635,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Product-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4639,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Deck-Officers-Maritime",
            "langCode": "en_US"
        }, {
            "id": 4639,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Deck-Officers-Maritime",
            "langCode": "zh_HK"
        }, {
            "id": 4639,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Deck-Officers-Maritime",
            "langCode": "zh_CN"
        }, {
            "id": 4640,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Ship-Engineers-Maritime",
            "langCode": "en_US"
        }, {
            "id": 4640,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Ship-Engineers-Maritime",
            "langCode": "zh_HK"
        }, {
            "id": 4640,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Ship-Engineers-Maritime",
            "langCode": "zh_CN"
        }, {
            "id": 4641,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Advertising-Art-Directors",
            "langCode": "en_US"
        }, {
            "id": 4641,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Advertising-Art-Directors",
            "langCode": "zh_HK"
        }, {
            "id": 4641,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Advertising-Art-Directors",
            "langCode": "zh_CN"
        }, {
            "id": 4642,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Digital-Marketing-Officers",
            "langCode": "en_US"
        }, {
            "id": 4642,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Digital-Marketing-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4642,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Digital-Marketing-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4644,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Publishers",
            "langCode": "en_US"
        }, {
            "id": 4644,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Publishers",
            "langCode": "zh_HK"
        }, {
            "id": 4644,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Publishers",
            "langCode": "zh_CN"
        }, {
            "id": 4645,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Editors",
            "langCode": "en_US"
        }, {
            "id": 4645,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Editors",
            "langCode": "zh_HK"
        }, {
            "id": 4645,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Editors",
            "langCode": "zh_CN"
        }, {
            "id": 4647,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Desktop-Publishing-DTP-E-Publishing-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4647,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Desktop-Publishing-DTP-E-Publishing-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4647,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Desktop-Publishing-DTP-E-Publishing-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4648,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Publication-Designers",
            "langCode": "en_US"
        }, {
            "id": 4648,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Publication-Designers",
            "langCode": "zh_HK"
        }, {
            "id": 4648,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Publication-Designers",
            "langCode": "zh_CN"
        }, {
            "id": 4649,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Facilities-Managers",
            "langCode": "en_US"
        }, {
            "id": 4649,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Facilities-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4649,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Facilities-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4650,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Estate-Surveyors",
            "langCode": "en_US"
        }, {
            "id": 4650,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Estate-Surveyors",
            "langCode": "zh_HK"
        }, {
            "id": 4650,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Estate-Surveyors",
            "langCode": "zh_CN"
        }, {
            "id": 4651,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Valuation-Surveyors",
            "langCode": "en_US"
        }, {
            "id": 4651,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Valuation-Surveyors",
            "langCode": "zh_HK"
        }, {
            "id": 4651,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Valuation-Surveyors",
            "langCode": "zh_CN"
        }, {
            "id": 4654,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/E-commerce-Managers",
            "langCode": "en_US"
        }, {
            "id": 4654,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/E-commerce-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4654,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/E-commerce-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4655,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Visual-Merchandisers",
            "langCode": "en_US"
        }, {
            "id": 4655,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Visual-Merchandisers",
            "langCode": "zh_HK"
        }, {
            "id": 4655,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Visual-Merchandisers",
            "langCode": "zh_CN"
        }, {
            "id": 4656,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/E-commerce-Assistants",
            "langCode": "en_US"
        }, {
            "id": 4656,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/E-commerce-Assistants",
            "langCode": "zh_HK"
        }, {
            "id": 4656,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/E-commerce-Assistants",
            "langCode": "zh_CN"
        }, {
            "id": 4657,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Sales",
            "langCode": "en_US"
        }, {
            "id": 4657,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Sales",
            "langCode": "zh_HK"
        }, {
            "id": 4657,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Sales",
            "langCode": "zh_CN"
        }, {
            "id": 4660,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Security-System-Managers",
            "langCode": "en_US"
        }, {
            "id": 4660,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Security-System-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4660,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Security-System-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4661,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Security-System-Engineers",
            "langCode": "en_US"
        }, {
            "id": 4661,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Security-System-Engineers",
            "langCode": "zh_HK"
        }, {
            "id": 4661,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Security-System-Engineers",
            "langCode": "zh_CN"
        }, {
            "id": 4662,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Security-Training-Managers",
            "langCode": "en_US"
        }, {
            "id": 4662,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Security-Training-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4662,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Security-Training-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4664,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Security-Training-Officers",
            "langCode": "en_US"
        }, {
            "id": 4664,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Security-Training-Officers",
            "langCode": "zh_HK"
        }, {
            "id": 4664,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Security-Training-Officers",
            "langCode": "zh_CN"
        }, {
            "id": 4667,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Security-System-Technicians",
            "langCode": "en_US"
        }, {
            "id": 4667,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Security-System-Technicians",
            "langCode": "zh_HK"
        }, {
            "id": 4667,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Security-System-Technicians",
            "langCode": "zh_CN"
        }, {
            "id": 4670,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Logistics-Warehouse-Managers",
            "langCode": "en_US"
        }, {
            "id": 4670,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Logistics-Warehouse-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4670,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Logistics-Warehouse-Managers",
            "langCode": "zh_CN"
        }, {
            "id": 4671,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Supply-Chain-Executives",
            "langCode": "en_US"
        }, {
            "id": 4671,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Supply-Chain-Executives",
            "langCode": "zh_HK"
        }, {
            "id": 4671,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Supply-Chain-Executives",
            "langCode": "zh_CN"
        }, {
            "id": 4673,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Accident-Investigation-and-Prevention-Specialists",
            "langCode": "en_US"
        }, {
            "id": 4673,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Accident-Investigation-and-Prevention-Specialists",
            "langCode": "zh_HK"
        }, {
            "id": 4673,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Accident-Investigation-and-Prevention-Specialists",
            "langCode": "zh_CN"
        }, {
            "id": 4675,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/Customs-Compliance-Managers",
            "langCode": "en_US"
        }, {
            "id": 4675,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/Customs-Compliance-Managers",
            "langCode": "zh_HK"
        }, {
            "id": 4675,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/Customs-Compliance-Managers",
            "langCode": "zh_CN"
        }
        , {
            "id": 8126,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/social-media-influencers",
            "langCode": "en_US"
        }, {
            "id": 8126,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/social-media-influencers",
            "langCode": "zh_HK"
        }, {
            "id": 8126,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/social-media-influencers",
            "langCode": "zh_CN"
        }
        , {
            "id": 8124,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/strategic-partnership-managers",
            "langCode": "en_US"
        }, {
            "id": 8124,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/strategic-partnership-managers",
            "langCode": "zh_HK"
        }, {
            "id": 8124,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/strategic-partnership-managers",
            "langCode": "zh_CN"
        }
        , {
            "id": 8122,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/robotic-process-automation-engineers",
            "langCode": "en_US"
        }, {
            "id": 8122,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/robotic-process-automation-engineers",
            "langCode": "zh_HK"
        }, {
            "id": 8122,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/robotic-process-automation-engineers",
            "langCode": "zh_CN"
        }
        , {
            "id": 8121,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/bim-modellers",
            "langCode": "en_US"
        }, {
            "id": 8121,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/bim-modellers",
            "langCode": "zh_HK"
        }, {
            "id": 8121,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/bim-modellers",
            "langCode": "zh_CN"
        }
        , {
            "id": 8118,
            "link": "https://occupation-dictionary.vtc.edu.hk/occupation/data-business-analysts",
            "langCode": "en_US"
        }, {
            "id": 8118,
            "link": "https://occupation-dictionary.vtc.edu.hk/tc/occupation/data-business-analysts",
            "langCode": "zh_HK"
        }, {
            "id": 8118,
            "link": "https://occupation-dictionary.vtc.edu.hk/sc/occupation/data-business-analysts",
            "langCode": "zh_CN"
        }]
}